import React from "react";
import { Space } from "antd";
import { AxBadge, AxAvatar, AxDivider, AxButton } from "@dynata/axiom3";

class Badge extends React.Component {
  render() {
    return (
      <div className="section" id="badge">
        <h3>Badge</h3>
        <p>Small numerical value or status descriptor for UI elements.</p>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <pre>{`<AxBadge count={99}>

</AxBadge>`}</pre>

          <div className="prop-header">
            <p className="props-title">Props</p>
            <p>
              For AntD props, visit{" "}
              <AxButton
                size="small"
                type="link"
                target="_blank"
                href="https://ant.design/components/badge/#API"
              >
                https://ant.design/components/badge/#API
              </AxButton>
            </p>
          </div>

          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>color</td>
                <td>Customize Badge dot color</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>count</td>
                <td>Number to show in badge</td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>dot</td>
                <td>
                  Whether to display a red dot instead of <code>count</code>
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>offset</td>
                <td>Set offset of the badge dot</td>
                <td>[number, number]</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>overflowCount</td>
                <td>Max count to show</td>
                <td>number</td>
                <td>99</td>
                <td></td>
              </tr>
              <tr>
                <td>showZero</td>
                <td>
                  Whether to show badge when <code>count</code> is zero
                </td>
                <td>boolean</td>
                <td>false</td>
                <td></td>
              </tr>
              <tr>
                <td>size</td>
                <td>
                  If <code>count</code> is set, <code>size</code> sets the size
                  of badge
                </td>
                <td>
                  <code>default</code> | <code>small</code>
                </td>
                <td>-</td>
                <td>4.6.0</td>
              </tr>
              <tr>
                <td>status</td>
                <td>Set Badge as a status dot</td>
                <td>
                  <code>success</code> | <code>processing</code> |{" "}
                  <code>default</code> | <code>error</code> |{" "}
                  <code>warning</code>
                </td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>text</td>
                <td>
                  If <code>status</code> is set, <code>text</code> sets the
                  display text of the status <code>dot</code>
                </td>
                <td>ReactNode</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>title</td>
                <td>Text to show when hovering over the badge</td>
                <td>string</td>
                <td>-</td>
                <td></td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to the{" "}
                  <>
                    <AxButton
                      size="small"
                      type="link"
                      target="_blank"
                      href="https://4x.ant.design/components/badge/#API"
                    >
                      {`<Badge />`}
                    </AxButton>
                  </>{" "}
                  component.
                </td>
                <td></td>
                <td>-</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <AxDivider orientation="left" plain>
            Default
          </AxDivider>

          <Space size="large" direction="vertical">
            <pre>{`
<AxBadge count={99}>
 <AxAvatar shape="square" size="large" />
</AxBadge>

<AxBadge count={9} status="success">
 <AxAvatar shape="square" />
</AxBadge>

<AxBadge count={9} status="error">
 <AxAvatar shape="square" />
</AxBadge>

<AxBadge count={9} status="default">
 <AxAvatar shape="square" />
</AxBadge>

<AxBadge count={9} status="warning">
 <AxAvatar shape="square" />
</AxBadge>`}</pre>
            <Space>
              <AxBadge count={99}>
                <AxAvatar shape="square" size="large" />
              </AxBadge>

              <AxBadge count={9} status="success">
                <AxAvatar shape="square" />
              </AxBadge>

              <AxBadge count={9} status="error">
                <AxAvatar shape="square" />
              </AxBadge>

              <AxBadge count={9} status="default">
                <AxAvatar shape="square" />
              </AxBadge>

              <AxBadge count={9} status="warning">
                <AxAvatar shape="square" />
              </AxBadge>
            </Space>
          </Space>

          <AxDivider orientation="left" plain>
            Status
          </AxDivider>

          <Space size="large" direction="vertical">
            <pre>{`
<AxBadge status="success" text="Success" />
<AxBadge status="error" text="Error" />
<AxBadge status="default" text="Default" />
<AxBadge status="processing" text="Processing" />
<AxBadge status="warning" text="Warning" />`}</pre>
            <Space>
              <AxBadge status="success" text="Success" />
              <AxBadge status="error" text="Error" />
              <AxBadge status="default" text="Default" />
              <AxBadge status="processing" text="Processing" />
              <AxBadge status="warning" text="Warning" />
            </Space>
          </Space>
        </Space>
      </div>
    );
  }
}
export default Badge;
